/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React, { useMemo, useRef, useEffect } from 'react'
import clsx from 'clsx'
import { useClickOutside } from 'hooks/useClickOutside'
import { useDropdownState } from './hooks/useDropdownState'
import { flattenOptions, filterOptionsForViewSelected, createOptionsMap } from './utils/dropdownUtils'
import { DropdownPanel } from './components/DropdownPanel'
import { DEFAULT_PROPS } from './consts'
import styles from './DropdownSelect.module.css'
import { ClearSelectionIcon } from './ClearSelectionIcon'

export const DropdownSelect = ({
  options,
  itemHeight = DEFAULT_PROPS.itemHeight,
  maxVisibleItems = DEFAULT_PROPS.maxVisibleItems,
  inputPlaceholder = DEFAULT_PROPS.inputPlaceholder,
  selectedValuesFunc = DEFAULT_PROPS.selectedValuesFunc,
  values = DEFAULT_PROPS.values,
  onApply,
  className,
  onClear,
}) => {
  const triggerRef = useRef(null)
  const listRef = useRef(null)
  const dropDownRef = useRef(null)
  const initalScrollToSelectedValue = useRef(null)

  const optionsMap = useMemo(() => createOptionsMap(options), [options])

  const {
    isOpen,
    search,
    viewSelectedMode,
    collapsed,
    selectedValues,
    setSearch,
    toggleCollapse,
    toggleValue,
    handleApply,
    handleClear,
    handleViewSelected,
    closeDropdown,
    openDropdown,
    setCollapsed,
  } = useDropdownState({
    initialValues: values,
    onApply,
    onClear,
    optionsMap,
  })

  const selectedText = useMemo(() => selectedValuesFunc(selectedValues.length), [selectedValuesFunc, selectedValues])

  const optionsList = useMemo(() => {
    const source = viewSelectedMode ? filterOptionsForViewSelected(options, selectedValues) : options
    return flattenOptions(source, 0, collapsed)
  }, [viewSelectedMode, options, selectedValues, collapsed])

  useEffect(() => {
    if (isOpen && listRef.current && selectedValues.length > 0 && initalScrollToSelectedValue.current === false) {
      const firstSelectedIndex = optionsList.findIndex((option) => selectedValues.includes(option.value))
      if (firstSelectedIndex >= 0) {
        listRef.current.scrollToItem(firstSelectedIndex, 'center')
      }

      initalScrollToSelectedValue.current = true
    }
  }, [isOpen, optionsList, selectedValues])

  useEffect(() => {
    const handleKeyUp = (e) => {
      if (e.key === 'Escape') {
        closeDropdown()
      }
    }

    document.addEventListener('keyup', handleKeyUp)
    return () => document.removeEventListener('keyup', handleKeyUp)
  }, [closeDropdown])

  useClickOutside([dropDownRef, triggerRef], closeDropdown)

  return (
    <div className={clsx(styles.dropdownWrapper, className)}>
      <div
        ref={triggerRef}
        className={clsx(styles.trigger, isOpen && styles.openedTrigger)}
        onClick={openDropdown}
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span>{selectedText}</span>

        {selectedValues.length > 0 && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={(e) => {
              e.stopPropagation()
              handleClear()
            }}
            aria-label="Clear selection"
          >
            <ClearSelectionIcon />
          </button>
        )}
      </div>

      {isOpen && (
        <DropdownPanel
          filteredOptions={optionsList}
          selectedValues={selectedValues}
          collapsed={collapsed}
          search={search}
          onSearchChange={setSearch}
          inputPlaceholder={inputPlaceholder}
          onToggleValue={toggleValue}
          onToggleCollapse={toggleCollapse}
          onApply={handleApply}
          onViewSelected={handleViewSelected}
          onClose={closeDropdown}
          viewSelectedMode={viewSelectedMode}
          itemHeight={itemHeight}
          maxVisibleItems={maxVisibleItems}
          listRef={listRef}
          panelRef={dropDownRef}
        />
      )}
    </div>
  )
}
